import React, { useEffect, useState } from "react";
import "./dashboard.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Instance from "../../AxiosConfig";

const CertificationGraph = () => {
  const [activeButton, setActiveButton] = useState("Monthly");
  const buttons = ["Daily", "Weekly", "Monthly"];
  const [certificationData, setCertificationData] = useState([]);
  const [loading, setLoading] = useState(true);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const fetchCertificationData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    let apiUrl = "";

    if (activeButton === "Daily") {
      apiUrl = "overview/certifications/stats/today/";
    } else if (activeButton === "Weekly") {
      apiUrl = "overview/certifications/stats/weekly";
    } else {
      apiUrl = "overview/certifications/stats?type=yearly&year=2025";
    }

    try {
      const response = await Instance.get(apiUrl, 
      //   {
      //   headers: { Authorization: `Bearer ${token}` },
      // }
    );

      if (response.status === 200 || response.status === 201) {
        const apiData = response.data?.data || response.data;

        let formattedData = [];

        if (activeButton === "Daily") {
          // Today API returns a single object
          formattedData = [
            {
              name: "Today",
              total: apiData.total || 0,
              active: apiData.active || 0,
              expired: apiData.inactive || 0,
            },
          ];
        } else if (activeButton === "Weekly") {
         
          if (Array.isArray(apiData)) {
             
            formattedData = apiData.flatMap((week) =>
              (week.days || []).map((day) => ({
                name: day.day,
                total: day.total || 0,
                active: day.active || 0,
                expired: day.inactive || 0,
              }))
            );
          } else {
             
            const daysArray = apiData.days || [];
            formattedData = daysArray.map((day) => ({
              name: day.day,
              total: day.total || 0,
              active: day.active || 0,
              expired: day.inactive || 0,
            }));
          }
        } else {
          // Monthly / Yearly API
          formattedData = apiData.map((item) => ({
            name: monthNames[item.month - 1] || "",
            total: item.total || 0,
            active: item.active || 0,
            expired: item.inactive || 0,
          }));
        }

        setCertificationData(formattedData);
      }
    } catch (error) {
      console.error("fetch error", error.response || error.message);
    } finally {
      setLoading(false);
    }
  };

  // Refetch data whenever the button changes
  useEffect(() => {
    fetchCertificationData();
  }, [activeButton]);

  return (
    <div className="certification-graph mt-4">
      <div className="bg-white rounded-2xl shadow-md">
        <div className="graph-header mb-4">
          <h2 className="text-lg font-semibold">Certification Performance</h2>
          <div className="button-group">
            {buttons.map((btn) => (
              <button
                key={btn}
                onClick={() => setActiveButton(btn)}
                className={`custom-btn ${
                  activeButton === btn ? "active-btn" : "inactive-btn"
                }`}
              >
                {btn}
              </button>
            ))}
          </div>
        </div>

        {/* Legend */}
        <div className="d-flex space-x-4 mb-4 ms-4 gap-4">
          <span className="text-blue-500 certification-overview-title">
            <span style={{ color: "#2196F3" }}>●</span> Total Certifications
          </span>
          <span className="text-green-500 certification-overview-title">
            <span style={{ color: "#4CAF50" }}>●</span> Active Certifications
          </span>
          <span className="text-red-500 certification-overview-title">
            <span style={{ color: "#FF0000" }}>●</span> Expired Certifications
          </span>
        </div>

        
        {loading ? (
          <p style={{ textAlign: "center", margin: "2rem" }}>
            Loading chart...
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={350} className="mb-2">
            <LineChart data={certificationData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis
                type="number"
                domain={[0, 90]}
                ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90]}
                tickFormatter={(value) => value.toString().padStart(2, "0")}
                allowDecimals={false}
                padding={{ top: 20, bottom: 0 }}
              />

              <Tooltip
                contentStyle={{ borderRadius: "12px", textAlign: "left" }}
                formatter={(value, name) => [
                  value,
                  name === "total"
                    ? "Total Certifications"
                    : name === "active"
                    ? "Active Certifications"
                    : "Expired Certifications",
                ]}
              />
              <Legend />

              <Line
                type="monotone"
                dataKey="total"
                stroke="#3B82F6"
                strokeWidth={2}
                dot={{ r: 5 }}
                activeDot={{ r: 7 }}
              />
              <Line
                type="monotone"
                dataKey="active"
                stroke="#22C55E"
                strokeWidth={2}
                dot={{ r: 5 }}
                activeDot={{ r: 7 }}
              />
              <Line
                type="monotone"
                dataKey="expired"
                stroke="#EF4444"
                strokeWidth={2}
                dot={{ r: 5 }}
                activeDot={{ r: 7 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default CertificationGraph;
